import React from "react";

import colours from '../../../../../../Common/DesignSystem/Colours';
import Icon from "../../../../../../Common/DesignSystem/Icons/Icon";

export const VehicleVINCell = ({ VIN }) => {
    if (!VIN) return null;

    const start = VIN.substr(0, 9);
    const end = VIN.substr(-8);

    const handleCopyVin = () => {
        navigator.clipboard.writeText(VIN);
        showStatusMsg(`VIN ${VIN} copied to clipboard`, 'success');
    }

    return (
        <div className="vehicle-vin">
            <div>
                <span style={{ color: colours.primary.grey02, fontWeight: 400 }}>{start}</span>
                <span>{end}</span>
            </div>

            <button onClick={handleCopyVin} style={{ cursor: 'pointer' }}>
                <Icon name="Copy" size={16} />
            </button>
        </div>
    )
};
